import { PatientAddress } from "./patientAddress";

export class PatientDrivingLicense {
  id: number;
  patientId: number;
  driversLicenseFrontPictureUrl: string | null;
  driversLicenseBackPictureUrl: string | null;
  active: boolean;
  addressId: number | null;
  dlNumber: string;
  class: string;
  expirationDate: string;
  patientAddress: PatientAddress;
  height: string | null;
  heightft: string = '';
  heightinch: string = '';
  weight: string | null;
  eyeColor: string | null;
  hairColor: string | null;
  bloodType: string | null;
}
